<script lang="ts" setup>
// Bloc « Nous contacter », commun au menu déroulant « AUTRES » et au tiroir mobile.
</script>

<template>
  <div>
    <p class="flex w-full justify-center my-2">
      Nous contacter
    </p>
    <div class="flex w-full justify-center my-3">
      <Icon
        name="lucide:phone"
        class="text-2xl text-black hover:text-primary mr-2 mx-4 cursor-pointer"
      />
      <Icon
        name="lucide:mail"
        class="text-2xl text-black hover:text-primary mr-2 mx-4 cursor-pointer"
      />
    </div>
  </div>
</template>
